import axios from 'axios';

const pvgisClient = axios.create({
  baseURL: '/pvgis-api',
  headers: { 'Content-Type': 'application/json' },
});

pvgisClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface PVGISEstimate {
  plant: {
    id: number;
    name: string;
    lat: number;
    lon: number;
    peakpower: number;
  };
  estimate: {
    inputs: any;
    outputs: {
      monthly: {
        fixed?: Array<any>;
      } | Array<any>;
      totals: {
        fixed: any;
      };
    };
  };
  radiation: {
    outputs: {
      monthly: {
        fixed?: Array<any>;
      } | Array<any>;
    };
  } | null;
}

export const fetchPVGISEstimate = async (uuid: string, refresh = false): Promise<PVGISEstimate> => {
  const response = await pvgisClient.get(`/estimate/${uuid}${refresh ? '?refresh=true' : ''}`);
  return response.data;
};

export const fetchActualProductionComparison = async (uuid: string, year?: number): Promise<{ year: number; data: Array<{ month: number; production: number }> }> => {
  // We use the main API for this, not the pvgis-api proxy
  const response = await axios.get(`/api/powerplants/${uuid}/pvgis-comparison${year ? `?year=${year}` : ''}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });
  return response.data;
};
